module.exports = __webpack_public_path__ + "media/icons/icon_ebitda-376f0355.png";